import { TableKeys } from 'src/app/models/table'
import { Status } from 'src/api/models'

export const CustomersTableKeys: Array<TableKeys> = [
  {
    title: 'Name',
    key: 'name',
    columnType: 'highlighted'
  },
  {
    title: 'Active',
    key: 'active',
    columnType: 'boolean'
  },
  {
    title: 'Status',
    key: 'status',
    columnType: 'status'
  }
];

export interface CustomerTableRow {
  id: number;
  name: string;
  status: Status;
}